import react from "react";
import useTyped from "../../../utils/hooks/useTypedOnScroll";

function TrustedAnalytics({ user }) {
  const [textScrollRef] = useTyped(
    ["Data", "AI", "Analytics", "Deep Learning"],
    {
      loop: true,
      typeSpeed: 40,
      backSpeed: 30,
      backDelay: 2500,
      showCursor: true,
    }
  );

  return (
    <section className="trusted__partner__section w-full ">
      <div className=" w-full mx-auto max-w-5xl pt-12 mb-0 lg:mb-4 flex justify-center">
        <h2 className="font-normal text-3xl lg:text-5xl text-center text-primary-blue-content">
          {`${user?.trustedSectionTitle} ` || "The trusted "}
          {/* <br /> */}
          <span className="font-bold" ref={textScrollRef} />
          {/* <br /> */}
          <span>
            {` ${user?.trustedSectionSecTitle}` || " Partner of Choice"}
          </span>
        </h2>

        <div id="string-text"></div>
      </div>

      <div className="credibility__body w-11/12 md:w-10/12 lg:w-8/12 2xl:w-7/12 mx-auto pb-12 flex justify-center">
        <p
          className="text-center text-primary-blue-content max-w-none"
          style={{ color: "#180f36" }}
        >
          {user?.trustedSectionSubText ||
            "Certilytics innovative approaches are helping leading healthcare organizations leverage predictive insights to identify the largest opportunities for better value-based care."}
        </p>
      </div>
    </section>
  );
}

export default TrustedAnalytics;
